import React from 'react'
import { createPortal } from 'react-dom'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { PATHS } from '@/utils/routes/paths'

// Figma 40:15336 — 신규(Okta) 회원가입 완료 페이지. /auth/okta-signup-complete
// OktaSignUp 성공 시 이 라우트로 navigate 한다(step 분기 대신 별도 URL).
function SignupComplete() {
  const navigate = useNavigate()

  // auth 레이아웃 배경이미지를 흰 전체화면으로 덮기 위해 document.body 에 포털 렌더(로그인/회원가입과 동일 패턴).
  return createPortal(
    <CompleteWrap>
      <CompleteInner>
        <CompleteIconTextWrap>
          <CompleteIconCircle>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path d="M5 12.5l5 5 9-10" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </CompleteIconCircle>
          <CompleteTitle>회원가입이 완료되었어요</CompleteTitle>
          <CompleteSub>
            <p style={{ margin: 0 }}>관리자가 순차 확인 중이에요</p>
            <p style={{ margin: 0 }}>빠른 승인은 관리자에게 직접 요청하세요</p>
          </CompleteSub>
        </CompleteIconTextWrap>
        <BackToLoginBtn type="button" onClick={() => navigate(PATHS['auth.login'])}>로그인으로 돌아가기</BackToLoginBtn>
      </CompleteInner>
    </CompleteWrap>,
    document.body,
  )
}

export default SignupComplete

/* ───────────── styled (Figma 40:15336 정확값) ───────────── */

const CompleteWrap = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
`

const CompleteInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: 335px;
`

const CompleteIconTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  width: 296px;
`

const CompleteIconCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const CompleteTitle = styled.p`
  font-size: 30px;
  font-weight: 500;
  color: #000;
  text-align: center;
  margin: 0;
  line-height: 1.4;
  word-break: keep-all;
`

const CompleteSub = styled.div`
  /* Figma 40:15341 — layerDesktop/base/text-xl: Pretendard Regular 16 / lh 1.36 / fg-low #666 */
  font-size: 16px;
  font-weight: 400;
  color: #666;
  text-align: center;
  line-height: 1.36;
`

const BackToLoginBtn = styled.button`
  /* Figma 40:15343 secondaryButton — h 52 / px spacing/500=20 py spacing/400=16 / rounded/xs=4
     label layerDesktop/base/text-l-medium: Pretendard Medium 15 / lh 1.36 / button/secondary/fg-low #666 */
  width: 100%;
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px; /* spacing/100 */
  padding: 16px 20px;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.36;
  letter-spacing: 0;
  color: #666;

  &:hover {
    opacity: 0.7;
  }
`
